import Button, { type Variation } from '@space-core/components/button'
import type { SectionProductDetail } from '@space-shell/common/services/sections'
import useProductClick from '@space-shell/modules/home/hooks/useProductClick'
import { getProductCallToActions } from '@space-shell/modules/products/utils/getProductCallToActions'
import { useSalesPage } from '@space-shell/modules/sales/presentation/hooks/common/use-sales-page'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'

const ButtonsContainer = styled.div`
  gap: 1rem;
`

export type ButtonsCallToActionsProps = {
  product: SectionProductDetail
  sectionId?: string
  isPreview?: boolean
}

export type CallToActionsProps = { to: string; label: string; type: string }

const ButtonsCallToActions = ({ product, sectionId, isPreview }: ButtonsCallToActionsProps) => {
  const {
    t,
    i18n: { language }
  } = useTranslation()
  const { membership: membershipSlug } = useParams()
  const internalSalesPageUrl = useSalesPage({ product })

  const handleProductClick = useProductClick({ product, sectionId })

  const { id, joined, freeSignUp, purchased, accessLink, productHotLink } = product

  const productHomeUrl = `/${language.toLocaleLowerCase()}/club/${membershipSlug}/products/${id}`
  const productUrl =
    !purchased && !joined && productHotLink ? productHotLink : accessLink || productHomeUrl

  const callToActions: CallToActionsProps[] = getProductCallToActions({
    joined,
    purchased,
    freeSignUp,
    productUrl,
    productHotLink,
    internalSalesPageUrl
  })

  return (
    <ButtonsContainer className='_d-flex _align_items-center'>
      {callToActions.map(({ label, to, type }) => (
        <Button
          key={label}
          variation={type as Variation}
          {...(!isPreview && { onClick: (event) => handleProductClick(event, to) })}
          className={clsx({
            '_w-hall': label === 'home.card_cta.purchase',
            '_w-full': label !== 'home.card_cta.purchase'
          })}>
          {t(label)}
        </Button>
      ))}
    </ButtonsContainer>
  )
}

export default ButtonsCallToActions
